export default "__VITE_ASSET__BjKM$bdR__"